import type { ResolutionEvent } from "../../domain/types/index.js";

/** 結果スタンプ・ボタンが出る種別以外は、すべて同じ位置の1行キャプションで伝える。 */
const NO_CAPTION_KINDS: ReadonlySet<ResolutionEvent["kind"]> = new Set(["success", "failure", "gameover"]);

export function EventCaption({ event }: { event: ResolutionEvent }) {
  if (NO_CAPTION_KINDS.has(event.kind) || !event.message) return null;
  return <p className="event-caption" role="status">{event.message}</p>;
}
